module.exports = __webpack_public_path__ + "static/media/bibme-logo.5cedde5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bibme-logo.svg
// module id = 5746
// module chunks = 11